<template>
  <div>
    <RowCard
      :theme="theme"
      class="align-start py-4"
      style="position: relative; min-height: 100px"
    >
      <div :style="{ width: headers[0].width }" class="flex-center ">
        <div v-if="item.form_type !== 'D' && item.form_type !== 'F'" class="flex-center gap-4">
        <v-btn
          v-if="item.status === 'Draft' || item.status === 'Inception'"
          small
          icon
          @click="onEdit"
        >
          <Iconify icon="material-symbols:edit" size="15px"></Iconify>
        </v-btn>
        <v-btn small icon @click="previewFormA">
          <Iconify icon="carbon:view-filled" size="15px"></Iconify>
        </v-btn>
        <v-btn 
          v-if="item.status === 'Draft'"
          small icon 
          @click="onDelete(item.id)"
          >
                <Iconify
                    style="color: #b1b1b1"
                    icon="basil:trash-alt-solid"
                    size="15px"
                ></Iconify>
        </v-btn>
      </div>
      </div>
      <div
        :style="{ width: headers[1].width }"
        :class="{ 'theme-color-seven': redText }"
      >
        {{ item.no }}
      </div>
      <div
        :style="{ width: headers[2].width }"
        :class="{ 'theme-color-seven': redText }"
      >
        {{ item.main_project?.fiscal_year }}
      </div>
      <div
        :style="{ width: headers[3].width }"
        :class="{ 'theme-color-seven': redText }"
      >
        <div
          class="one-line mb-5"
          :class="[redText ? 'theme-color-seven' : 'black--text']"
          style="height: 20px"
        >
          {{ item.main_project?.name }}
        </div>
        <div
          v-if="item.main_project?.start_date && item.main_project?.end_date"
          class="one-line font-type-normal"
        >
          ระยะเวลาเปิดรับโครงการ :
          {{
            toDateRangeFormat(
              item.main_project.start_date,
              item.main_project.end_date
            )
          }}
        </div>
      </div>
      <div
        :style="{ width: headers[4].width }"
        :class="[
          { 'theme-color-seven': redText }
        ]"
      >
        {{ item?.created_by ?? "ไม่มีข้อมูล" }}
      </div>
      <div
        :style="{ width: headers[5].width }"
        :class="[
          { 'theme-color-seven': redText }
        ]"
      >
        {{ item?.created_at ? toDateTimeFormat(item?.created_at) : "ไม่มีข้อมูล" }}
      </div>
      <div :style="{ width: headers[6].width }">
        {{ item.region }}
      </div>
      <div
        :style="{
          width: headers[7].width,
          color: statusColorSeparator(item.status),
        }"
      >
        {{ item.status }}
      </div>
      <div :style="{ width: headers[8].width }"></div>

      <v-btn
        absolute
        top
        right
        icon
        :class="{ rotate180: isExpanded }"
        @click="seeDetail"
      >
        <Iconify
          icon="material-symbols:keyboard-arrow-down"
          color="#D3D3D3"
        ></Iconify>
      </v-btn>
    </RowCard>

    <div class="expand-layout px-5" :class="[rand]">
      <div class="expand-content">
        <div class="d-flex justify-space-between gap-12 theme-color-eight">
          <div style="min-width: 8%; max-width: 8%"></div>
          <div style="min-width: 62%; max-width: 62%">แผนงาน</div>
          <div style="min-width: 30%; max-width: 30%">สถานะ</div>
        </div>

        <v-divider class="my-3"></v-divider>

        <div
          v-if="item.main_project && item.main_project.plan"
          class="d-flex flex-column gap-8"
        >
          <div v-for="(x, i) in item.main_project.plan" :key="i">
            <div class="d-flex justify-space-between align-center gap-12">
              <div style="min-width: 8%; max-width: 8%">
                <v-btn
                  v-if="
                    x.form_b &&
                    (item.status === 'Draft' || item.status === 'Inception')
                  "
                  small
                  icon
                  @click="editFormByType(x.form_b.id , item?.form_type)"
                >
                  <v-icon color="#F15A29" size="15px"> mdi-pencil </v-icon>
                </v-btn>
                <v-btn
                  small
                  icon
                  v-if="x.form_b"
                  @click="previewFormByType(x.form_b.id , item?.form_type)"
                >
                  <Iconify
                    icon="carbon:view-filled"
                    color="var(--theme-color-seven)"
                    size="15px"
                  ></Iconify>
                </v-btn>
              </div>
              <div style="min-width: 62%; max-width: 62%">
                {{ x.plan_master?.plan_name_th }}
              </div>
              <div style="min-width: 30%; max-width: 30%">
                <div v-if="x.form_b">
                  {{ x.form_b.status }}
                </div>

                <Button
                  v-else
                  height="36px"
                  theme="3"
                  @onClick="createBForm(x.id)"
                >
                  สร้างฟอร์ม B
                </Button>
              </div>
            </div>
          </div>

          <div
            v-if="item.status === 'Approved'"
            class="d-flex align-center gap-12"
          >
            <Button v-if="item.form_type !== 'D'" @onClick="extendRequest"> ยื่นขอขยายเวลา </Button>
            <Button @onClick="progressReport('progress', item.form_type)">
              รายงานความก้าวหน้า
            </Button>
            <Button @onClick="progressReport('final', item.form_type)">
              รายงานฉบับสมบูรณ์
            </Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "./input/Button";
import RowCard from "../components/RowCard";
import { toDateRangeFormat, toDateTimeFormat } from "../plugins/global-funcs";

export default {
  name: "MainProjectOfferItem",
  components: {
    Button,
    RowCard,
  },
  props: {
    item: {
      default: () => ({}),
    },
    index: {
      default: 0,
    },
    headers: {
      default: () => [],
    },
  },
  data() {
    return {
      toDateRangeFormat,
      toDateTimeFormat,
      rand: "cl-" + Math.random().toString().slice(2),
      theme: 2,
      redText: false,
      isExpanded: false,
    };
  },
  methods: {
    seeDetail() {
      let growDiv = document.querySelector("." + this.rand + ".expand-layout");
      if (growDiv.clientHeight) {
        growDiv.style.height = 0;
        this.isExpanded = false;
      } else {
        let wrapper = document.querySelector(
          "." + this.rand + " .expand-content"
        );
        growDiv.style.height = wrapper.clientHeight + 20 + "px";
        this.isExpanded = true;
      }
    },
    statusColorSeparator(status) {
      switch (status) {
        case "Draft":
          this.theme = 2;
          this.redText = true;
          return "var(--theme-color-seven)";

        case "Submitted1":
          this.theme = 5;
          return "var(--theme-color-five)";

        case "Rejected":
          this.theme = 4;
          return "var(--theme-color-four)";

        case "Submitted2":
          this.theme = 10;
          return "var(--theme-color-ten)";

        case "Approved":
        case "Completed":
        case "Inception":
          this.theme = 3;
          return "var(--theme-color-three)";

        default:
          return "var(--theme-color-two)";
      }
    },
    onEdit() {
      this.$router.push({ name: "FormA", query: { id: this.item.id } });
    },
    previewFormA() {
      this.$router.push({
        name: "FormA",
        query: { id: this.item.id, preview: true },
      });
    },
    createBForm(id) {
      this.$router.push({
        name: "FormB",
        query: { form_a_id: this.item.id, plan_id: id },
      });
    },
    editFormByType(id ,type) {
      if(type === 'D'){
        this.$router.push({ name: "FormD", query: { id: id } });
      }else if (type === 'F'){
        this.$router.push({ name: "FormF", query: { id: id } });
      }else{
        this.$router.push({ name: "FormB", query: { id: id } });
      }
    },
    previewFormByType(id,type) {
      if(type === 'D'){
        this.$router.push({ name: "FormD", query: { id: id, preview: true } });
      }else if (type === 'F'){
        this.$router.push({ name: "FormF", query: { id: id, preview: true } });
      }else{
        this.$router.push({ name: "FormB", query: { id: id, preview: true } });
      }
    },
    async extendRequest() {
      if(this.item.form_type === 'F'){
        this.$router.push(`/rsp/extend-time/${this.item.main_project.plan[0].form_b.id}/form`);
      }else{
        let res = await this.$apiFire(
            "RSPExtend/createPendingGroup",
            this.item.id
        );

        if (res) {
          this.$router.push({
            name: "RSPExtendTimeList",
          });
        }
      }
    },
    async progressReport(type, form_type) {
      let res = await this.$apiFire("AForm/storeNewProgressFormA", {
        id: this.item.id,
        doc_type: type,
      });
      if (typeof res === "number") {
        if(form_type === 'D') {
          this.$router.push({
            name: "FormD",
            query: {id: res, doc_type: "progress"},
          });
        }else if(form_type === 'F') {
          this.$router.push({
            name: "FormF",
            query: {id: res, doc_type: "progress"},
          });
        }else {
          this.$router.push({
            name: "FormA",
            query: {id: res, doc_type: "progress"},
          });
        }
      }
    },
    onDelete(id) {
      console.log(id)
      // sweetalert confirm
      this.$store.commit("General/setModal", {
        theme: "delete",
        title: "ลบข้อมูล ?",
        text: "ท่านยืนยันที่จะลบข้อมูลหรือไม่?",
        buttonText: "ยืนยัน",
        cancelText: "ยกเลิก",
        action: async () => {
          let res = await this.$apiFire("AForm/deleteFormAList",id);
          if (res) {
            // this.$store.commit("General/setModal", {
            //   title: "เสร็จสิ้น!",
            //   theme: "success",
            //   text: res,
            //   showCancel: false,
            // });
            window.location.reload();
          }
        },
      });
    },
  },
};
</script>

<style scoped>
.left-side {
  min-width: 40px;
  max-width: 40px;
}

.btn-pos {
  position: absolute;
  bottom: 24px;
  right: 24px;
}

.expand-layout {
  -moz-transition: height 0.2s;
  -ms-transition: height 0.2s;
  -o-transition: height 0.2s;
  -webkit-transition: height 0.2s;
  transition: height 0.2s;
  height: 0;
  overflow: hidden;
}
.expand-content {
  padding: 24px;
  background: #fafafa;
  box-shadow: 1px 1px 20px rgba(0, 0, 0, 0.1);
  border-radius: 0 0 20px 20px;
}
</style>
